/* eslint-disable @typescript-eslint/no-explicit-any */
import { Fragment, useMemo, useRef, useState } from "react";
import { SortableContext, useSortable } from "@dnd-kit/sortable";
import TaskCard from "./TaskCard";
import { Button, Dropdown, Popover } from "antd";
import { CloseCircleOutlined, MoreOutlined } from "@ant-design/icons";
// import RouteIcon from "../../../../atoms/CustomIcons/RouteIcon";
import ConfirmIcon from "../../../../atoms/CustomIcons/ConfirmIcon";
import RescheduleIcon from "../../../../atoms/CustomIcons/RescheduleIcon";
import UnscheduleIcon from "../../../../atoms/CustomIcons/UnscheduleIcon";

import FlagIcon from "../../../../atoms/CustomIcons/FlagIcon";
import { PopUp } from "../../../../atoms/PopUp";
import ConfirmDelete from "../../../../atoms/ConfirmDelete";
import { SuccessMessage } from "../../../../atoms/Toasts/SuccessMessage";
import RescheduleRemainingOrWhole from "../RescheduleRemainingOrWhole";
import dayjs from "dayjs";
import MakeDayOff from "../MakeDayOff";
import EditStartFinishPoint from "../EditStartFinishPoint";
import MoveCrewScheduleBy from "../MoveCrewScheduleBy";
import ChangeShiftYardTime from "../ChangeShiftYardTime";
// import RouteCalculate from "../../../../atoms/CustomIcons/RouteCalculate";
// import MoveIcon from "../../../../atoms/CustomIcons/MoveIcon";
// import ChangeShift from "../../../../atoms/CustomIcons/ChangeShift";
import HomeIcon from "../../../../atoms/CustomIcons/HomeIcon";
// import DayOffIcon from "../../../../atoms/CustomIcons/DayOffIcon";
import { formatCrewLeaderName } from "../../../../config/utils";
import { SelectArrow } from "../../../../atoms/CustomIcons";
// import TimeSheetIcon from "../../../../atoms/CustomIcons/TimeSheetIcon";
import HourCard from "./HourCard";
import CrewCard from "./CrewCard";
import SimpleTaskCard from "./SimpleTaskCard";
import {
  confirmWorkOrders,
  moveScheduleToDate,
  // moveScheduleToDate,
  setDayOff,
  unscheduleAllRemainingVisits,
} from "../../ducks/services";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../atoms/Toasts/ErrorMessage";
import { getScheduleByDay } from "../../ducks/actions";
import { useAppDispatch } from "../../../../config/hooks";
import DayOffIcon from "../../../../atoms/CustomIcons/DayOffIcon";
import MoveIcon from "../../../../atoms/CustomIcons/MoveIcon";

function ColumnContainer(props: any) {
  const {
    column,
    tasks,
    setScheduleId,
    setShowScheduled,
    crewDrop,
    selectedDate,
    isDragging,
    setLoading,
    loading,
  } = props;

  const [scheduleContainer, setScheduleContainer] = useState<any>(null);
  const [confirmAllUnschedule, setConfirmAllUnschedule] = useState(false);
  const [dayOffData, setDayOffData] = useState<any>(null);
  const tasksId = useMemo(
    () => tasks?.map((task: { id: number }) => task?.id),
    [tasks]
  );

  const { setNodeRef } = useSortable({
    id: column.id,
    data: {
      type: "Column",
      column,
    },
  });
  const dropdownRef = useRef<HTMLButtonElement>(null);

  const moveScheduleToDateFunc = (days: string) => {
    setLoading(true);
    const payload = {
      schedule_id: scheduleContainer?.id,
      date: dayjs(selectedDate).add(Number(days), "day").format("YYYY-MM-DD"),
    };
    moveScheduleToDate(payload)
      .then(() => {
        const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
        dispatch(getScheduleByDay(formattedDate));
        SuccessMessage("Scheduled moved");
        setConfirmAllWO(false);
        setLoading(false);
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
          setLoading(false);
        } else {
          ErrorMessage("Something went wrong");
          setLoading(false);
        }
      });
  };

  const discardChanges = () => {
    setLoading(true);

    const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
    dispatch(getScheduleByDay(formattedDate));

    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const items = [
    // {
    //   key: "1",
    //   label: (
    //     <Button
    //       type="text"
    //       className="no-hover"
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         if (dropdownRef.current) {
    //           dropdownRef?.current?.click();
    //         }
    //       }}
    //     >
    //       <RouteIcon /> Show route on a map
    //     </Button>
    //   ),
    // },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setConfirmAllWO(true);
          }}
        >
          <ConfirmIcon /> Confirm all work orders
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setRescheduleVisitModal(true);
          }}
        >
          <RescheduleIcon /> Reschedule remaining visits
        </Button>
      ),
    },
    {
      key: "4",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            setConfirmAllUnschedule(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
        >
          <UnscheduleIcon /> Unschedule all remaining visits
        </Button>
      ),
    },
    // {
    //   key: "5",
    //   label: (
    //     <Button
    //       type="text"
    //       className="no-hover"
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         if (dropdownRef.current) {
    //           dropdownRef?.current?.click();
    //         }
    //       }}
    //     >
    //       <TimeSheetIcon /> Open timesheet
    //     </Button>
    //   ),
    // },
    {
      key: "6",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setEditFinishPointModal(true);
          }}
        >
          <FlagIcon /> Edit finish point
        </Button>
      ),
    },
    {
      key: "7",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setEditStartPointModal(true);
          }}
        >
          <HomeIcon /> Edit start point
        </Button>
      ),
    },
  ];

  const itemsFuture = [
    // {
    //   key: "1",
    //   label: (
    //     <Button
    //       type="text"
    //       className="no-hover"
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         // if (dropdownRef.current) {
    //         //   dropdownRef?.current?.click();
    //         // }
    //       }}
    //     >
    //       <RouteCalculate /> Calculate route
    //     </Button>
    //   ),
    // },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            discardChanges();
          }}
        >
          <CloseCircleOutlined /> Discard unpublished changes
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setRescheduleVisitModal(true);
          }}
        >
          <MoveIcon /> Reschedule the whole day
        </Button>
      ),
    },
    {
      key: "4",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            setConfirmAllUnschedule(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
        >
          <UnscheduleIcon /> Unschedule all remaining visits
        </Button>
      ),
    },
    {
      key: "5",
      label: (
        <Popover
          arrow={false}
          content={
            <>
              <Button
                type="text"
                className="no-hover"
                onClick={() => moveScheduleToDateFunc("1")}
              >
                1 day forward
              </Button>
              <Button
                type="text"
                className="no-hover"
                onClick={() => moveScheduleToDateFunc("2")}
              >
                2 days forward
              </Button>
              <Button
                type="text"
                className="no-hover"
                onClick={(e) => {
                  e.stopPropagation();
                  if (dropdownRef.current) {
                    dropdownRef?.current?.click();
                  }
                  setMoveCrewScheduleByModal(true);
                }}
              >
                Custom period ...
              </Button>
            </>
          }
          // trigger="click"
          placement="rightTop"
          getPopupContainer={(trigger) =>
            trigger.parentElement || document.body
          }
        >
          <Button type="text" className="no-hover">
            <RescheduleIcon /> Move crew’s schedule by ...
          </Button>
        </Popover>
      ),
    },
    // {
    //   key: "6",
    //   label: (
    //     <Button
    //       type="text"
    //       className="no-hover"
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         if (dropdownRef.current) {
    //           dropdownRef?.current?.click();
    //         }
    //         setChangeShiftYardTimeModal(true);
    //       }}
    //     >
    //       <ChangeShift /> Change shift & yard time
    //     </Button>
    //   ),
    // },
    {
      key: "7",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setEditStartPointModal(true);
          }}
        >
          <HomeIcon /> Edit start point
        </Button>
      ),
    },
    {
      key: "8",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setEditFinishPointModal(true);
          }}
        >
          <FlagIcon /> Edit finish point
        </Button>
      ),
    },
    {
      key: "9",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setMakeDayOffModal(true);
          }}
        >
          <DayOffIcon /> Make a day-off
        </Button>
      ),
    },
  ];
  const dispatch = useAppDispatch();
  const [confirmAllWO, setConfirmAllWO] = useState(false);
  const [rescheduleVisitModal, setRescheduleVisitModal] = useState(false);
  const [editStartPointModal, setEditStartPointModal] = useState(false);
  const [editFinishPointModal, setEditFinishPointModal] = useState(false);

  const [changeShiftYardTimeModal, setChangeShiftYardTimeModal] =
    useState(false);
  const [moveCrewScheduleByModal, setMoveCrewScheduleByModal] = useState(false);
  const [makeDayOffModal, setMakeDayOffModal] = useState(false);

  // const totalHoursForColumn =
  //   column?.visit?.reduce((sum: any, visit: any) => {
  //     const start = dayjs(visit.start);
  //     const end = dayjs(visit.end);
  //     // Calculate duration in hours (as a float)
  //     const visitDurationHours = end.diff(start, "hour", true);
  //     return sum + visitDurationHours;
  //   }, 0) || 0; // Default to 0 if no visits or calculation fails

  // // Calculate the maximum possible hours for the crew in this column
  // // This is based on your existing logic: crewMembers.length * 8
  // const maxCrewHours = (column?.crewMembers?.length || 0) * 8;

  // // Calculate the percentage for the progress bar
  // // Handle division by zero if maxCrewHours is 0
  // const progressBarPercent =
  //   maxCrewHours > 0 ? (totalHoursForColumn / maxCrewHours) * 100 : 0;

  const btnConfirmAllWorkOrders = async () => {
    setLoading(true);
    const payload = {
      schedule_id: scheduleContainer?.id,
    };
    confirmWorkOrders(payload)
      .then(() => {
        const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
        dispatch(getScheduleByDay(formattedDate));
        SuccessMessage("Work orders confirmed");
        setConfirmAllWO(false);
        setLoading(false);
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
          setLoading(false);
        } else {
          ErrorMessage("Something went wrong");
          setLoading(false);
        }
      });
  };

  const btnRescheduleVisits = async () => {
    SuccessMessage("Visits rescheduled");
    setRescheduleVisitModal(false);
  };
  const btnChangeShiftYardTime = async () => {
    SuccessMessage("Shift start time changed");
    setChangeShiftYardTimeModal(false);
  };

  const btnEditStartPoint = async () => {
    SuccessMessage("Start point changed");
    setEditStartPointModal(false);
  };
  const btnEditFinishPoint = async () => {
    SuccessMessage("Finish point changed");
    setEditFinishPointModal(false);
  };
  const btnMakeDayOff = async () => {
    setLoading(true);
    const payload = {
      crew_id: dayOffData === "only" ? scheduleContainer?.crew_id : undefined,
      date: dayjs(selectedDate).format("YYYY-MM-DD"),
    };
    setDayOff(payload)
      .then(() => {
        const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
        dispatch(getScheduleByDay(formattedDate));
        SuccessMessage("Day off scheduled");
        setMakeDayOffModal(false);
        setLoading(false);
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
          setLoading(false);
        } else {
          ErrorMessage("Something went wrong");
          setLoading(false);
        }
      });
  };

  const unscheduleAllRemainingVisitsApi = async () => {
    setLoading(true);
    const payload = {
      schedule_id: scheduleContainer?.id,
    };
    unscheduleAllRemainingVisits(payload)
      .then(() => {
        setConfirmAllUnschedule(false);
        const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
        dispatch(getScheduleByDay(formattedDate));
        SuccessMessage("All remaining visits unscheduled");
        setLoading(false);
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
          setLoading(false);
        } else {
          ErrorMessage("Something went wrong");
          setLoading(false);
        }
      });
  };

  const unscheduleAllRemainingVisitsPopUp = {
    visibility: confirmAllUnschedule,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setConfirmAllUnschedule(false)}
        heading="Confirm unschedule"
        paragraph="Are you sure you want to unschedule"
        btnText="Confirm"
        btnApi={unscheduleAllRemainingVisitsApi}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setConfirmAllUnschedule(false),
  };

  const confirmAllWorkOrdersPopUp = {
    visibility: confirmAllWO,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setConfirmAllWO(false)}
        heading="Confirm all work orders for this route"
        paragraph={
          <Fragment>
            This will mark all work orders completed by the crew as confirmed.
            <br />
            <br />
            Are you sure you want to proceed?
          </Fragment>
        }
        btnText="Confirm"
        loading={loading}
        isArchivePopup
        btnApi={btnConfirmAllWorkOrders}
      />
    ),
    width: 480,
    onCancel: () => setConfirmAllWO(false),
  };

  const rescheduleVisit = {
    visibility: rescheduleVisitModal,
    content: (
      <RescheduleRemainingOrWhole
        onClose={() => setRescheduleVisitModal(false)}
        btnApi={btnRescheduleVisits}
        loading={loading}
        scheduleId={scheduleContainer?.id}
        crewId={scheduleContainer?.crew_id}
        setLoading={setLoading}
        oldDate={selectedDate}
      />
    ),
    width: 360,
    onCancel: () => setRescheduleVisitModal(false),
  };
  const changeShiftYardTime = {
    visibility: changeShiftYardTimeModal,
    content: (
      <ChangeShiftYardTime
        onClose={() => setChangeShiftYardTimeModal(false)}
        btnApi={btnChangeShiftYardTime}
        loading={false}
      />
    ),
    width: 385,
    onCancel: () => setChangeShiftYardTimeModal(false),
  };
  const moveCrewScheduleBy = {
    visibility: moveCrewScheduleByModal,
    content: (
      <MoveCrewScheduleBy
        onClose={() => setMoveCrewScheduleByModal(false)}
        loading={loading}
        setLoading={setLoading}
        selectedDate={selectedDate}
        scheduleId={scheduleContainer?.id}
      />
    ),
    width: 480,
    onCancel: () => setMoveCrewScheduleByModal(false),
  };
  const editStartPoint = {
    visibility: editStartPointModal,
    content: (
      <EditStartFinishPoint
        onClose={() => setEditStartPointModal(false)}
        btnApi={btnEditStartPoint}
        loading={loading}
        scheduleId={scheduleContainer?.id}
        isStartPoint={true}
        title="Edit start point"
        selectedDate={selectedDate}
        setLoading={setLoading}
        paragraph="By default, the crew starts their day at their assigned yard. When needed, you can change it to a different location."
      />
    ),
    width: 480,
    onCancel: () => setEditStartPointModal(false),
  };
  const editFinishPoint = {
    visibility: editFinishPointModal,
    content: (
      <EditStartFinishPoint
        onClose={() => setEditFinishPointModal(false)}
        btnApi={btnEditFinishPoint}
        loading={loading}
        scheduleId={scheduleContainer?.id}
        isStartPoint={false}
        title="Edit finish point"
        selectedDate={selectedDate}
        setLoading={setLoading}
        paragraph="By default, the crew finishes their day at their assigned yard. When needed, you can change it to a different location."
      />
    ),
    width: 480,
    onCancel: () => setEditFinishPointModal(false),
  };
  const makeDayOff = {
    visibility: makeDayOffModal,
    content: (
      <MakeDayOff
        onClose={() => setMakeDayOffModal(false)}
        btnApi={btnMakeDayOff}
        setDayOffData={setDayOffData}
        dayOffData={dayOffData}
        loading={loading}
        selectedDate={selectedDate}
        column={column}
      />
    ),
    width: 480,
    onCancel: () => setMakeDayOffModal(false),
  };

  const today = dayjs();
  const comparisonDate = dayjs(selectedDate);

  console.log("column:", column);

  // const totalScheduledMinutes =
  //   tasks?.reduce(
  //     (sum: number, task: any) =>
  //       sum + (task?.durationMinutes + +task?.drive_time || 0),
  //     0
  //   ) || 0;

  let crewYardStartName = "";
  let crewYardFinishName = "";

  if (column?.starting_point === "CREW_YARD") {
    crewYardStartName = column?.starting_crew_yard_name || "";
  } else if (column?.starting_point === "PROPERTY") {
    crewYardStartName = column?.starting_property_name || "";
  } else if (column?.starting_point === "CUSTOM") {
    crewYardStartName = column?.starting_custom_location_name || "";
  }

  if (column?.finish_point === "CREW_YARD") {
    crewYardFinishName = column?.finish_crew_yard_name || "";
  } else if (column?.finish_point === "PROPERTY") {
    crewYardFinishName = column?.finish_property_name || "";
  } else if (column?.finish_point === "CUSTOM") {
    crewYardFinishName = column?.finishing_custom_location_name || "";
  }
  const totalVisitsDuration =
    column?.visits?.reduce((sum: number, visit: any) => {
      return sum + visit?.duration;
    }, 0) || 0;
  return (
    <div className="column_wrapper" ref={setNodeRef}>
      <div className="column_header">
        <div className="column_title">
          <span>{column?.crew_name}</span>{" "}
          {formatCrewLeaderName(column?.crew_leader_name)}
        </div>
        <div
          className="column_actions"
          style={{ width: "28px", height: "28px" }}
        >
          {column?.visits?.length > 0 && (
            <Dropdown
              menu={{
                items: comparisonDate.isAfter(today, "day")
                  ? itemsFuture
                  : items,
              }}
              trigger={["click"]}
              placement="bottomLeft"
              className="actionButton"
            >
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  setScheduleContainer(column);
                }}
                onKeyDown={(e) => e.stopPropagation()}
                className="white_border"
                icon={<MoreOutlined />}
                ref={dropdownRef}
              />
            </Dropdown>
          )}
        </div>
      </div>
      <div className="columns_info">
        <HourCard
          column={column}
          isWeekend={
            dayjs(selectedDate).day() === 0 || dayjs(selectedDate).day() === 6
          }
          actualHours={
            (totalVisitsDuration +
              (column?.starting_point_duration || 0) / 60 +
              ((column?.finish_point_duration || 0) / 60 || 0)) *
            (column?.crewAttendances?.length > 0
              ? column?.crewAttendances?.length
              : (column?.crewMembers?.length || 0) + 1)
          }
          totalHours={
            (column?.visits?.length > 0
              ? column?.crewAttendances?.length > 0
                ? column?.crewAttendances?.length
                : (column?.crewMembers?.length || 0) + 1
              : 0) * 8 || 0
          }
          // actualHours={
          //   (totalVisitsDuration + (column?.starting_point_duration || 0)) /
          //     60 +
          //   ((column?.finish_point_duration || 0) / 60) *
          //     (column?.crewAttendances?.length > 0
          //       ? column?.crewAttendances?.length
          //       : (column?.crewMembers?.length || 0) + 1)
          // }
          // totalHours={
          //   (column?.visits?.length > 0
          //     ? column?.crewAttendances?.length ?? 1
          //     : 0) * 8 || 0
          // }
        />
        <CrewCard
          column={column}
          crewDrop={crewDrop}
          selectedDate={selectedDate}
          setLoading={setLoading}
          loading={loading}
          isWeekend={
            dayjs(selectedDate).day() === 0 || dayjs(selectedDate).day() === 6
          }
        />
      </div>

      <div className="column_content">
        {dayjs(selectedDate).day() !== 0 && dayjs(selectedDate).day() !== 6 && (
          <SimpleTaskCard
            crewYardName={crewYardStartName}
            selectedDate={selectedDate}
            durationMinutes={column?.starting_point_duration}
            isFirstIndex
          />
        )}
        <SortableContext items={tasksId}>
          {tasks?.length > 0 ? (
            tasks?.map((task: any) => (
              <TaskCard
                key={task.id}
                task={task}
                selectedDate={selectedDate}
                crewId={column?.crew_id}
                setLoading={setLoading}
                loading={loading}
                oldDate={selectedDate}
                // dateInFuture={
                //   task?.start
                //     ? dayjs(task?.start)?.isAfter(dayjs(), "minutes")
                //     : false
                // }
              />
            ))
          ) : (
            <div className="no_task" style={{ textAlign: "center" }}>
              {dayjs(selectedDate).day() === 0 ||
              dayjs(selectedDate).day() === 6 ? (
                <>
                  <h6>Day off</h6>
                  <p>No visits planned</p>
                </>
              ) : (
                <>
                  <h6>No visits planned</h6>
                  <p>Place a work order here to create a visit</p>
                </>
              )}
            </div>
          )}
        </SortableContext>
        {dayjs(selectedDate).day() !== 0 && dayjs(selectedDate).day() !== 6 && (
          <SimpleTaskCard
            crewYardName={crewYardFinishName}
            selectedDate={selectedDate}
            durationMinutes={column?.finish_point_duration}
            isLastIndex
          />
        )}
        {!isDragging &&
          dayjs(selectedDate).day() !== 0 &&
          dayjs(selectedDate).day() !== 6 && (
            <Button
              onClick={() => {
                setScheduleId(column?.crew_id);
                setShowScheduled(true);
              }}
              className="view_schedule_button"
              icon={<SelectArrow />}
            >
              View schedule
            </Button>
          )}
      </div>

      <PopUp {...confirmAllWorkOrdersPopUp} />
      <PopUp {...rescheduleVisit} />
      <PopUp {...changeShiftYardTime} />
      <PopUp {...moveCrewScheduleBy} />
      <PopUp {...editStartPoint} />
      <PopUp {...editFinishPoint} />
      <PopUp {...makeDayOff} />
      <PopUp {...unscheduleAllRemainingVisitsPopUp} />
    </div>
  );
}

export default ColumnContainer;
